import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const COUNTRIES = [
  // MVP
  { code: "AU", name: "Australia", flag: "🇦🇺", phase: "mvp" },
  { code: "UK", name: "United Kingdom", flag: "🇬🇧", phase: "mvp" },
  { code: "US", name: "United States", flag: "🇺🇸", phase: "mvp" },
  { code: "DE", name: "Germany", flag: "🇩🇪", phase: "mvp" },
  { code: "NL", name: "Netherlands", flag: "🇳🇱", phase: "mvp" },
  // Phase 2
  { code: "CA", name: "Canada", flag: "🇨🇦", phase: "phase2" },
  { code: "IE", name: "Ireland", flag: "🇮🇪", phase: "phase2" },
  { code: "SG", name: "Singapore", flag: "🇸🇬", phase: "phase2" },
  { code: "FR", name: "France", flag: "🇫🇷", phase: "phase2" },
  { code: "SE", name: "Sweden", flag: "🇸🇪", phase: "phase2" },
  { code: "NZ", name: "New Zealand", flag: "🇳🇿", phase: "phase2" },
];

export const fmtINR = (n) => {
  if (n == null) return "—";
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2)} Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(1)} L`;
  return `₹${n.toLocaleString("en-IN")}`;
};
